module.exports = __webpack_public_path__ + "static/media/nv.41736f27.png";